import { Component, Input, inject } from '@angular/core';
import { FilterState } from '../../../generic/classes/filter.state';
import { ProductDetail } from '../../../generic/classes/product.detail';
import { Logger } from '../../../generic/logging/default-log.service';
import { FavoriteService } from '../../../generic/service/favorite.service';
import { FilterService } from '../../../generic/service/filter.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'product-favorite',
    styleUrls: ['./favorite.component.scss'],
    template: ` <button
          class="product-favorite-button"
          [ngClass]="{ active: product.favorite }"
          (click)="toggleFavorite()"
          [disabled]="awaitingResponse">
          @if (product.available) {
            @if (!product.favorite) {
              <span
                class="product-favorite-button__text theme-primary-text-color"
                i18n="Add favorite@@add.favorite">
                Add favorite
            </span>
            }
            @if (product.favorite) {
              <span
                class="product-favorite-button__text theme-primary-text-color"
                i18n="Remove favorite@@remove.favorite">
                Remove favorite
            </span>
            }
          }
          <span class="product-favorite-button__icon">
            <svg class="icon-heart" width="24" height="21">
              <use xlink:href="/images/icons/svg-sprite.svg#heart"></use>
            </svg>
          </span>
        </button>`,
    standalone: true,
    imports: [NgClass],
})
export class ProductFavoriteComponent {
    private favoriteService = inject(FavoriteService);
    private filterService = inject(FilterService);
    private logger = inject(Logger);

    @Input() product: ProductDetail;

    awaitingResponse: boolean = false;

    /**
     * Set or unset favorite status based on current status.
     * Disable button while awaiting response of backend call.
     */
    toggleFavorite() {
        const filterState: FilterState = this.filterService.getFilterState();

        this.awaitingResponse = true;

        this.favoriteService
            .toggleFavorite(this.product, filterState)
            .subscribe({
                next: favorite => {
                    this.product.favorite = favorite;
                },
                error: error => {
                    this.logger.error(
                        'Failed to toggle favorite for ' +
                            this.product.totalDescription1,
                        error,
                    );
                },
                complete: () => {
                    this.awaitingResponse = false;
                },
            });
    }
}
